<template>
    <svg viewBox="0 0 360 360" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(-314.7947,-6.3674202)">
            <path
                fill="#0073ff"
                d="m 407.03,69.68 c -46.79,0 -84.72,37.93 -84.72,84.72 h 141.91 c 0,0 27.53,-84.72 27.53,-84.72 z"
            />
            <path
                fill="#0073ff"
                d="M 582.17,73.83 C 567.71,29.33 519.92,4.98 475.42,19.44 v 0 l 43.85,134.97 h 89.08 c 0,0 -26.18,-80.57 -26.18,-80.57 z"
            />
            <path
                fill="#0073ff"
                d="m 632.35,241.68 c 37.85,-27.5 46.25,-80.48 18.74,-118.34 v 0 l -114.81,83.41 27.53,84.72 68.54,-49.8 z"
            />
            <path
                fill="#0073ff"
                d="m 488.22,341.28 c 37.85,27.5 90.84,19.11 118.34,-18.74 v 0 l -114.81,-83.41 -72.07,52.36 68.54,49.8 z"
            />
            <path
                fill="#0073ff"
                d="m 348.96,234.97 c -14.46,44.5 9.89,92.29 54.39,106.75 v 0 l 43.85,-134.97 -72.07,-52.36 -26.18,80.57 z"
            />
        </g>
    </svg>
</template>
